export enum CmsItemType {
  File = 1,
  Html = 2,
  Image = 3,
  Text = 4,
}
